import {twMerge} from 'tailwind-merge';

type Props = {
  children: React.ReactNode;
  className?: string;
  RightComponent?: React.ReactNode;
};

const SectionHeading = ({children, className, RightComponent}: Props) => {
  return (
    <div
      className={twMerge(
        'flex items-center justify-between w-full mb-6 max-sm:mb-4 gap-6 max-sm:flex-col max-sm:items-start',
        className
      )}
    >
      <div className="flex flex-col gap-3">
        <h2 className="text-3xl font-heading font-semibold mt-2 max-md:text-2xl max-sm:text-xl leading-tight max-md:leading-[1.2]">
          {children}
        </h2>
        <div className="h-px w-[40%] bg-[rgb(23_10_37_/_0.07)] dark:bg-[rgb(255_255_255_/_0.1)] max-w-[360px]" />
      </div>

      {RightComponent}
    </div>
  );
};

export default SectionHeading;
